import PropTypes from 'prop-types';

const StatisticsHeightIcon = ({ className, size = 17, rowSpan = 1 }) => {
	const isTall = rowSpan >= 2;
	const barWidth = 9.6;
	const barHeight = isTall ? 4.1 : 9.6;
	const gap = 1.35;
	const offsetX = (16 - barWidth) / 2;
	const bars = isTall ? [0, 1] : [0];

	return (
		<svg
			className={className}
			width={size}
			height={size}
			viewBox='0 0 16 16'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			aria-hidden='true'
		>
			{bars.map((index) => {
				const totalHeight = bars.length * barHeight + (bars.length - 1) * gap;
				const offsetY = (16 - totalHeight) / 2 + index * (barHeight + gap);
				return (
					<rect
						key={index}
						x={offsetX}
						y={offsetY}
						width={barWidth}
						height={barHeight}
						rx='0.9'
						stroke='currentColor'
						strokeWidth='1.2'
						opacity={index === 0 ? 1 : 0.72}
					/>
				);
			})}
		</svg>
	);
};

StatisticsHeightIcon.propTypes = {
	className: PropTypes.string,
	size: PropTypes.number,
	rowSpan: PropTypes.oneOf([1, 2]),
};

export default StatisticsHeightIcon;
